<div class="appContainer">

  <!-- LOGO -->
  <app-logo [siteBrand]="logoBrand()"></app-logo>
  @if (!startup.routePath().toLowerCase().includes('delete') &&
    !startup.routePath().toLowerCase().includes('accessdata') &&
    !startup.routePath().toLowerCase().includes('landing') &&
    !startup.routePath().toLowerCase().includes('success') &&
    !startup.routePath().toLowerCase().includes('failure')) {
    <!-- BANNER -->
    <app-banner [siteBrand]="startup.siteBrand()" [isPc]="startup.isPc()"></app-banner>
  }

  <router-outlet></router-outlet>

</div>


